<template>
  <div style="background-color: black;" class="my-video">
    <video v-show="isShowPlayer" id="myvideo" ref="videoPlayer"
      :style="{ 'height': videoHeight + 'px', 'width': appWidth + 'px' }" :poster="poster" x5-playsinline=""
      x5-video-player-fullscreen='true' playsinline="" webkit-playsinline="" controls autoplay @play="bindplay"
      @timeupdate="timeupdate" @pause="pause" />
    <div class="vip" v-show="isShow && videoPaidCategory === 0">{{ pvCount }}人正在观看 <span @click="openPkay">¥{{ price }}
        立即观看</span></div>
  </div>
</template>

<script>
import { GetBMGameLiveDetail } from '@/api/match'
import Hls from 'hls.js'
import { IsOnPC, QNImageUtil } from '@/utils'
let appWidth = 0
export default {
  props: {
    gameId: {
      default: ''
    },
    isBoughtLive: Boolean,
    isVideoPaid: Boolean,
    pvCount: String,
    price: String,
    videoPaidCategory: Number
  },
  data() {
    return {
      isShowPlayer: false, // 显示隐藏
      videoHeight: '', // 高度
      poster: '封面',
      game: {},
      liveStatus: {},
      appWidth: 0,
      videoStream: '',
      videoJsPlayer: null,
      videoPlayer: null, // 播放器
      videoUrl: '', // 直播地址
      isShow: false,
      isTryAndSee: false, //是否试看
    };
  },
  created() {
    this.getGameDetails()
  },
  watch: {
    isVideoPaid: {
      handler() {
        if (!(this.isVideoPaid && !this.isBoughtLive)) {
          this.isShow = false
        } else {
          this.isShow = true
        }
      },
      immediate: true
    }
  },
  mounted() {
    appWidth = this.appWidth = document.getElementById('app').clientWidth
    this.videoHeight = appWidth * 9 / 16
    console.log(window.localStorage.getItem('isTryAndSee') !== this.gameId, this.gameId);
    if (window.localStorage.getItem('isTryAndSee') != this.gameId) {
      window.localStorage.setItem('isTryAndSee', this.gameId)
    } else {
      console.log(222);
      this.isTryAndSee = true
    }
  },
  methods: {
    getGameDetails() {
      GetBMGameLiveDetail({ gameId: this.gameId, fromBmYouth: true }).then(response => {
        const data = response.data
        this.game = data.game
        console.log(data);
        let liveStatus = this.liveStatus = data.liveInfo && data.liveInfo.liveStatus || {} // 直播状态
        this.videoStream = liveStatus.streams && liveStatus.streams[0]
        // 根据status确定是否初始化播放器
        if (liveStatus.status === 1 || liveStatus.status === 2) {
          // 设置live-player的src
          if (!this.isShowPlayer) { // 确保初始化一次，可以和adplayer一起初始化，如直播时候
            this.$nextTick(() => {
              // 初始化播放器
              this.isShowPlayer = true
              this.videoPlayer = this.$refs['videoPlayer']
              this.$refs.videoPlayer.style.display = ''
              // this.playerListener(this.videoPlayer)
              // (this.branding && !this.branding.video) TODO 直播不放广告
              if ((liveStatus.status === 1) || liveStatus.status === 2) {
                this.initVideo()
              }
            })
          }
          if (liveStatus.status === 1) {
            this.loopLiveState() // 轮询初始化，便于状态更新
          }
        }
      })
    },
    // 初始化video
    initVideo(self) {
      self = self || this
      if (!self.videoPlayer) return
      self.playVideoAutoSwitch(self.videoStream, self.videoPlayer)
      let poster = self.videoStream.poster
      if (this.branding && this.branding.img) {
        poster = this.branding.img
      }
      self.poster = self.filterImage(poster, appWidth, self.videoHeight)
    },
    playVideoAutoSwitch(stream, player) {
      if (stream.streamUrlMp4) {
        stream.streamUrlMp4 += '?attname=' + this.videoStream.videoId + '.mp4'
      }
      let videoUrl = stream.streamUrlHls || stream.streamUrlMp4 // 手机端hls stream 优先播放
      if (stream.streamUrlMp4 && IsOnPC()) { // pc mp4 优先
        videoUrl = stream.streamUrlMp4
      }
      this.videoUrl = videoUrl
      // http 转换 https
      // if (videoUrl.indexOf('https') < 0) {
      //   videoUrl = videoUrl.replace('http', 'https')
      // }
      // let videoUrl = stream.streamUrlMp4 || stream.streamUrlHls//有mp4优先播放
      if (player.canPlayType('application/vnd.apple.mpegurl')) {
        player.setAttribute('src', videoUrl)
      } else if (videoUrl.indexOf('.m3u8') > -1) {
        // var Hls = window.Hls || null
        if (Hls && Hls.isSupported()) {
          var hls = new Hls()
          hls.loadSource(videoUrl)
          hls.attachMedia(player)
        } else {
          // this.errorMsg.desc = '视频资源不支持，请在移动端观看直播'
        }
      } else {
        player.setAttribute('src', videoUrl)
      }
      // player.load()
      player.play()
    },
    loopLiveState() {
      window.setInterval(() => {
        this.getGameLiveInfo()
        // this.getGameDetailScore()
      }, 5000)
    },
    getGameLiveInfo() {
      GetBMGameLiveDetail({ gameId: this.gameId, fromBmYouth: true }).then(response => {
        if (response) {
          const data = response.data
          let liveStatus = this.liveStatus = data.liveStatus || {}
          this.videoStream = liveStatus.streams && liveStatus.streams[0]

          // 根据status确定是否初始化播放器
          if (liveStatus.status === 1 || liveStatus.status === 2) {
            // 设置live-player的src
            this.initVideoJSPlayer()
          }
        }
      })
    },
    initVideoJSPlayer() {
      if (this.videoJsPlayer == null) {
        this.videoJsPlayer = this.$refs['videoPlayer']
        this.playVideoAutoSwitch(this.videoStream, this.videoPlayer)
        let poster = this.videoStream.poster
        if (this.branding && this.branding.img) {
          poster = this.branding.img
        }
        this.poster = this.filterImage(poster, appWidth, this.videoHeight)
      }
    },
    playVideoAutoSwitchVJ(videoStream) {
      // if (this.init) {
      //   this.init = false
      //   return
      // }
      if (this.videoStream.streamUrlMp4 && IsOnPC()) {
        if (this.videoStream.streamUrlMp4.indexOf('.mp4') == -1) {
          this.videoStream.streamUrlMp4 += '?attname=' + this.videoStream.videoId + '.mp4'
        }
        this.videoUrl = this.videoStream.streamUrlMp4
        this.videoJsPlayer.src(videoStream.streamUrlMp4)
      } else if (this.videoStream.streamUrlHls) {
        this.videoUrl = videoStream.streamUrlHls
        this.videoJsPlayer.src(videoStream.streamUrlHls)
      } else if (this.videoStream.streamUrlMp4) {
        this.videoUrl = this.videoStream.streamUrlMp4 + '?attname=' + this.videoStream.videoId + '.mp4'  // 手机端hls stream 优先播放
        this.videoJsPlayer.src(this.videoUrl)
      } else if (this.videoStream.videoId == '') {
        this.outTime = true
        document.getElementById('myvideo').style.display = 'none'
      }
      this.videoJsPlayer.load()
      this.videoJsPlayer.play()
      
    },
    filterImage(img, w, h) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10))
    },
    bindplay() {
      this.$emit('play')
      if (this.isVideoPaid && !this.isBoughtLive) {
        this.isShow = false
      }
    },
    pause() {
      if (this.isVideoPaid && !this.isBoughtLive) {
        this.isShow = true
      }
    },
    openPkay() {
      this.$emit('openPkay')
    },
    timeupdate(e) {
      let time = e.srcElement.currentTime
      // if( window.localStorage.getItem('isBol') === this.gameId  && this.isVideoPaid && !this.isBoughtLive){
      //   e.srcElement.pause()
      //   this.$emit('payVideo')
      //   this.isShow = true
      //   return
      // } else {
      //   window.localStorage.setItem('isBol', this.gameId)
      // } true false
      if (this.isTryAndSee && this.isVideoPaid && !this.isBoughtLive && this.videoPaidCategory === 0) {
        e.srcElement.pause()
        this.$emit('payVideo')
        this.isShow = true
        return
      }
      if (time > 60 && this.isVideoPaid && !this.isBoughtLive && this.videoPaidCategory === 0) {
        e.srcElement.pause()
        this.$emit('payVideo')
        this.isShow = true
      }
    }
  },
};
</script>

<style scoped lang="scss">
.my-video {
  position: relative;

  .vip {
    position: absolute;
    bottom: 60px;
    left: 50%;
    width: 264px;
    height: 32px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 16px;
    transform: translateX(-50%);
    color: #fff;
    font-size: 12px;
    line-height: 32px;
    text-align: center;

    span {
      font-weight: 500;
      color: #E0CBA7;
      margin-left: 12px;
    }
  }
}
</style>
